import React, {useEffect} from 'react';
import {Navigate} from "react-router-dom";
import {checkUser, LOCAL_STORAGE_TOKEN, logout} from "../redux-store/auth";
import {useDispatch, useSelector} from "react-redux";
import {getAutoRedirect, isAuthenticated, isCheckUserInProgress} from "../redux-store/selectors";
import {ResponseStatus} from "../constants/responseStatus";
import Page403 from "./ErrorPage/Page403";
import Page500 from "./ErrorPage/Page500";
import {logOutUser} from "./authHelpers";

const ProtectedRoute = ({children, isAllowed = true, redirectPath = "/"}) => {
    const dispatch = useDispatch();
    const authToken = localStorage.getItem(LOCAL_STORAGE_TOKEN)
    const authenticated = useSelector(isAuthenticated);
    const checkUserInProgress = useSelector(isCheckUserInProgress);
    const autoRedirect = useSelector(getAutoRedirect);

    useEffect(() => {
        if (!authenticated && authToken) {
            dispatch(checkUser())
        } else if ((!authenticated && !authToken) || authToken === null) {
            logOutUser()
        }
    }, [authenticated, checkUserInProgress, dispatch, authToken])

    if (!authToken && !authenticated) return <Navigate to="/login"/>

    if (checkUserInProgress) return;

    if (!isAllowed) {
        return <Navigate to={redirectPath} replace/>;
    }

    if (autoRedirect === ResponseStatus.FORBIDDEN)
        return <Page403/>
    else if (autoRedirect === ResponseStatus.INTERNAL_ERROR)
        return <Page500/>

    return children;
};

export default ProtectedRoute;
